import './App.css';
import StakingApp from './Staking.js';
//import Cover from './Cover.png';
import DesktopCover from './Cover.jpg';
import MobileCover from './CoverMobile.jpg';
import CoverLogo from './CoverLogo.png'
import { Web3Button } from '@web3modal/react'
import { useState } from 'react';
import hamburger from './hamburger.svg';
import { readContracts } from '@wagmi/core'
import { useAccount } from 'wagmi'
import ABI from './ABI.json'


const contractAddress = '0x4Ec902d04F4F1c840B28CffeE2E52d807af4710E';

function App() {
  const totalBears = 6500;
  const [stakingShowing,setStakingShowing] = useState(false);
  const [totalStakes,setTotalStakes] = useState("...");
  const [percentStaked,setPercentStaked] = useState("...")
  const [totalClaimed,settotalClaimed] = useState("...");

  loadInfo();

  const { address } = useAccount({
    onConnect({address}) {
      if(!stakingShowing){
        toggleStaking();
      }
    },
    onDisconnect() {
      if(stakingShowing){
        toggleStaking();
      }
    }
  });

  async function loadInfo(){
    await getStats();
  }

  async function getStats(){
    await readContracts({
      contracts: [
        {
          address: contractAddress,
          abi: ABI,
          functionName: 'getTotalStaked',
        },
        {
          address: contractAddress,
          abi: ABI,
          functionName: 'getAccumulatedHarvestedPoints',
        }
      ],
    }).then((data)=>{
      const stakedBears = data[0].result.toLocaleString();
      
      const percent = (Number(data[0].result) * 100) / totalBears;
      setTotalStakes(stakedBears);
      setPercentStaked(percent.toFixed(2)+"%");
      settotalClaimed(data[1].result.toLocaleString())
    }).catch(()=>{});
  }
  async function showStaking(){
    const Hamburger = document.getElementById("Hamburger");
    const StakingApp = document.getElementById("StakingApp");
    const Cover = document.getElementById("Cover");
    Hamburger.classList.remove("HamburgerCover");
    Hamburger.classList.add("HamburgerStaking");
    Cover.classList.add("FadeOut");
    await new Promise(resolve => setTimeout(resolve, 700));
    StakingApp.classList.remove("StakingAppHidden");
    StakingApp.classList.add("StakingAppVisible");
    if(StakingApp.classList.contains("FadeOut")){
      StakingApp.classList.remove("FadeOut");}
    await new Promise(resolve => setTimeout(resolve, 700));
  }
  async function hideStaking(){
    const Hamburger = document.getElementById("Hamburger");
    const StakingApp = document.getElementById("StakingApp");
    const Cover = document.getElementById("Cover");
    Hamburger.classList.add("HamburgerCover");
    Hamburger.classList.remove("HamburgerStaking");
    StakingApp.classList.remove("StakingAppVisible");
    StakingApp.classList.add("FadeOut");
    await new Promise(resolve => setTimeout(resolve, 700));
    Cover.classList.remove("FadeOut");
    Cover.classList.add("FadeIn");
    await new Promise(resolve => setTimeout(resolve, 700));
  }
  function toggleStaking(){
    if(stakingShowing==false){
      showStaking()
      setStakingShowing(true);
    }
    else{
      hideStaking()
      setStakingShowing(false);
    }
  }
  var expanded = false;
  var moving = false;

  async function expandSidebar(){
    if(moving===true || expanded===true){
      return;
    }
    moving = true;
    expanded = true;
    let sidebar = document.getElementsByClassName("Sidebar")[0];
    sidebar.classList.add("expanded");
    moving = false;
  }
  async function collapseSidebar(){
    if(moving===true || expanded===false){
      return;
    }
    moving = true;
    expanded = false;
    let sidebar = document.getElementsByClassName("Sidebar")[0];
    sidebar.classList.remove("expanded");
    moving = false;
  }
  function toggleSidebar(){
    if (!expanded) {
      expandSidebar();

    } else {
      collapseSidebar();
    }
  }
  return (
    <div className="App">
      <img src={hamburger} id="Hamburger" className="Hamburger HamburgerCover" alt="menu" onClick={()=>{
          toggleSidebar();
        }}/>
      <table className='Sidebar' frame="void">
        <span onClick={()=>{
          toggleSidebar();
        }}>X</span>
        <tbody>
          <tr>
            <td className='SidebarOption'>
              <a  target="_blank" href="http://rivalbears.io" style={{textDecoration:"none",color:"inherit"}}>
                Home
              </a>
            </td>
          </tr>
          <tr>
            <td className='SidebarOption'>
              <a  target="_blank" href="https://magiceden.io/collections/polygon/0xa25541164ae9d59322b59fe94a73869b494c3691" style={{textDecoration:"none",color:"inherit"}}>
                  Rival Bears
              </a>
            </td>
          </tr>
          <tr>
            <td className='SidebarOption'>
              <a  target="_blank" href="https://magiceden.io/collections/polygon/0x86c18085b8949ff3dc53ec5c3a3a143ccfbc960a" style={{textDecoration:"none",color:"inherit"}}>
                Mad Honey
              </a>
            </td>
          </tr>
        </tbody>
      </table>
      <div className='Cover' id="Cover">
        <center>
          <picture className='CoverImg'>
            <source media="(max-width:900px)" srcset={MobileCover}/>
            <img src={DesktopCover} className='Picture'/>
          </picture>
          <div className='CoverLogo'>
            <img src={CoverLogo}/>
          </div>
          <div className='ConnectButton'>
            <Web3Button/>
          </div>
          <div className='Stats'>
            <div>
              <span className='Label'>Honey Points Claimed</span>
              <br/>
              {totalClaimed}
            </div>
            <div>
            <span className='Label'>&nbsp;&nbsp;Rival Bears Staked&nbsp;&nbsp;</span>
              <br/>
              {totalStakes}
            </div>
            <div>
            <span className='Label'>&nbsp;&nbsp;&nbsp;&nbsp;% of Total Staked&nbsp;&nbsp;&nbsp;&nbsp;</span>
              <br/>
              {percentStaked}
            </div>
          </div>
        </center>
      </div>
      <StakingApp/>
    </div>
  );
}

export default App;
